import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
} from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject } from 'rxjs';
import { Revenue } from '../../../../model/revenue';
import { IRevenueApiService } from './revenue-api.interface';
import { FindRevenueQueryDto } from './dtos/find-revenue.query.dto';
import { FindRevenueResponseDto } from './dtos/find-revenue.response.dto';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { ExportRevenueQueryDto } from './dtos/export-revenue.query.dto';

@Injectable({
  providedIn: 'root',
})
export class RevenueMockApiService implements IRevenueApiService {
  data = {
    revenues: {
      items: [] as Revenue[],
      queryOptions: { page: 1, size: 10 } as QueryOptions<Revenue>,
      subject: new BehaviorSubject<Maybe<Revenue[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get revenuesData() {
    return this.data['revenues'] as Data<Revenue, Revenue>;
  }

  findRevenue(query: FindRevenueQueryDto): Promise<FindRevenueResponseDto> {
    throw new Error('Method not implemented.');
  }
  exportRevenue(query: ExportRevenueQueryDto, options?: HandleBlobHttpResponseOptions): void {
    throw new Error('Method not implemented.');
  }
}
